import { Button } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { get } from "lodash";
import React from "react";
import { useNotify, useTranslate } from "react-admin";
import { CopyToClipboard } from "react-copy-to-clipboard";

const CopyLinkButton = ({ source, record, network }) => {
	const translate = useTranslate();
	const notify = useNotify();
	if (!get(record, source)) {
		// canale non ancora assegnato: nessun link da copiare
		return null;
	}
	const link = `https://${get(network, "channel_domain_name")}/${get(
		record,
		source
	)}`;
	return (
		<CopyToClipboard
			text={link}
			onCopy={() =>
				notify(translate("resources.channels.messages.link_copied", { link }))
			}
		>
			<Button color="primary" startIcon={<FileCopyIcon />}>
				{translate("resources.channels.buttons.copy_link")}
			</Button>
		</CopyToClipboard>
	);
};
export default CopyLinkButton;
